import { ContentBlock } from "../../types/contentBlock";
import { TestimonialSwiper } from "../../types/TestimonialSwiper";
import { linkQuery } from "./link";

export const testimonialSwiperQuery = `
    _type == "testimonialSwiper" => {
    title,
    testimonials[] {
        quote,
        name,
        customerProject
    },
    link {
        ${linkQuery}
    }
}`

export const isTestimonialSwiper = (solution: ContentBlock): solution is TestimonialSwiper => {
    return solution._type === 'testimonialSwiper';
}